import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {handleClick} from './utilities';

export const AdditionalArticles = ({element, key, context}) => {
  return (
    <div key={key} className='additional-article'>
      {element?.articleImage && <Image className='article-image' src={element?.articleImage} />}
      {element?.heading && <span className='article-heading' dangerouslySetInnerHTML={{__html: element?.heading}} />}
      {element?.publisher && element?.articleDate && (
        <div className='date-publisher'>
          <p className='publisher'>{element?.publisher}</p>
          <div className='vertical-line'>|</div>
          <p className='article-date'>{element?.articleDate}</p>
        </div>
      )}
      {element?.articleContent && <span className='article-content' dangerouslySetInnerHTML={{__html: element?.articleContent}} />}
      {element?.articleLink && (
        <span className='article-link' onClick={() => handleClick(element?.articleLink, context)}>
          המשך קריאה
        </span>
      )}
    </div>
  );
};
